import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppIcon } from '../home/icon';
import { ARTICLES } from './learn-content';

@Component({
  selector: 'app-learn',
  standalone: true,
  imports: [RouterLink, AppIcon],
  templateUrl: './learn.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../terms/terms.scss', './learn.scss']
})
export class Learn {
  readonly articles = ARTICLES;
}
